<template>
  <div class="dataTableWrapper">
    <mds-layout-grid>
      <mds-row>
        <mds-col :cols="12" :cols-at-s="5">
          <mds-search-field
            :class="$style['cf-instanceSearchWrapper']"
            placeholder="Search Instances"
            variation="secondary"
            label="Search"
            size="medium"
            v-model="searchQuery"
            @Keyup="resultQuery"
          ></mds-search-field
        ></mds-col>

        <mds-col :cols="12" :cols-at-s="7" :class="$style['textR']">
          <mds-button-container :class="$style['flexE']">
            <mds-button
              variation="primary"
              size="medium"
              v-if="isAllowCompare"
              @click="getUserSelectedRow()"
              :disabled="isCompareButtonDisable"
            >
              {{ compareButtonText }}
            </mds-button>
            <mds-button
              variation="primary"
              icon="plus"
              size="medium"
              @click="$emit('createNew')"
            >
              {{ buttonText }}
            </mds-button>
          </mds-button-container>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
    <div :class="$style['cf-datatable']" v-if="!emptyState">
      <mds-table row-hover show-sortable>
        <mds-thead>
          <mds-th
            v-for="(header, index) in headers"
            :key="index"
            :right-aligned="header.align === 'right'"
            :sortable="header.sortable"
            :sorted="header.sorted"
            :style="header.style"
            @mds-th-sort-changed="
              handleSortEvent(index, header.fieldName, $event)
            "
          >
            {{ header.text }}
          </mds-th>
        </mds-thead>

        <mds-tbody v-if="rows.length > 0">
          <mds-tr
            :class="$style['cf-row']"
            v-for="(row, index) in resultQuery"
            :key="index"
          >
            <mds-td
              v-for="(header, i) in headers"
              :key="i"
              :right-aligned="header.align === 'right'"
              :style="header.styleRow"
            >
              <template v-if="header.fieldType === 'checkbox'">
                <mds-checkbox
                  style="margin-top: 8px; margin-left: 8px"
                  hidden-label
                  v-model="row[header.fieldName]"
                  @change.native="
                    checkRowSelectedCount(index, header.fieldName)
                  "
                ></mds-checkbox>
              </template>
              <template v-else-if="header.fieldType === 'tag'">
                <div :class="$style['cf-tag']">
                  <mds-tag
                    :class="$style['cf-tag-inner']"
                    v-if="row.isFromFact != ''"
                  >
                    {{ row.isFromFact }}
                  </mds-tag>
                  <mds-tag
                    :class="$style['cf-tag-outer']"
                    v-if="row.tagName != ''"
                  >
                    {{ row.tagName }}
                  </mds-tag>
                </div>
              </template>
              <template v-else-if="header.fieldType === 'action'">
                <mds-button
                  size="small"
                  variation="secondary"
                  :id="'multi-sections-trigger' + index"
                  :class="
                    selectedActionIndex == index
                      ? $style['cf-ActionHover show']
                      : $style['cf-ActionHover']
                  "
                  @click="
                    selectedActionIndex = index;
                    actionToggle = !actionToggle;
                  "
                  icon-right="caret-down"
                >
                  {{ actionButtonText }}
                </mds-button>
                <mds-popover
                  v-if="selectedActionIndex == index"
                  @click="actionHover(index)"
                  width="200px"
                  :triggered-by="'multi-sections-trigger' + index"
                  v-model="actionToggle"
                  :position="['bottom-right', 'bottom-center']"
                >
                  <mds-list-group>
                    <mds-list-group-item
                      :icon="action.icon"
                      :key="action.id"
                      v-for="action in row.actionButtons"
                    >
                      <span
                        @click="
                          actionToggle = false;
                          $emit(action.emitevent, row);
                        "
                        >{{ action.text }}</span
                      >
                    </mds-list-group-item>
                  </mds-list-group>
                </mds-popover>
              </template>
              <template v-else-if="header.fieldType === 'profile'">
                <div :class="$style['cf-profileInitialsWrapper']">
                  <span
                    v-for="(profile, i) in row.profiles"
                    :key="i"
                    :class="$style['cf-profileInitials']"
                    :style="initialsColor(profile.type)"
                    @click="selectedProfileIndex = index"
                    @mouseover="
                      setMember(profile);
                      selectedProfileIndex = index;
                    "
                    @mouseleave="
                      profileToggle = false;
                      selectedProfileIndex = index;
                    "
                    @focus="
                      setMember(profile);
                      selectedProfileIndex = index;
                    "
                    @blur="
                      profileToggle = false;
                      selectedProfileIndex = index;
                    "
                    :id="'default-trigger' + index"
                  >
                    {{ profile.tag }}
                  </span>

                  <mds-tooltip
                    size="small"
                    v-if="selectedProfileIndex == index"
                    :triggered-by="'default-trigger' + index"
                    v-model="profileToggle"
                    :position="['bottom-center', 'top-center']"
                  >
                    {{ selectedMember.name }}
                  </mds-tooltip>
                </div>
              </template>
              <template v-else-if="header.fieldType === 'date'">
                <div :class="$style['cf-date']">
                  {{ row[header.fieldName] }}
                </div>
              </template>
              <template v-else-if="header.fieldType === 'metadata'">
                <mds-list-group>
                  <span @click="selectedDetails(row)">
                    <mds-list-group-item
                      :class="$style['removeExtraPadding']"
                      text=""
                      :metadata-below="getrowmetadata(row, header)"
                    >
                      <div>{{ row[header.fieldDescription] }}</div>
                    </mds-list-group-item></span
                  >
                </mds-list-group>
              </template>
              <template v-else="header.fieldType === 'text'">
                <div>
                  {{ row[header.fieldText] }}
                </div>
              </template>
            </mds-td>
          </mds-tr>
        </mds-tbody>
      </mds-table>
    </div>
    <div :class="$style['cf-blank-searchResults']" v-if="emptyState">
      <mds-empty-state
        :title="emptyResultMessage"
        message="Try Searching for"
        :list="emptyStateResult"
        size="medium"
      >
        <template #mds-empty-state-icon>
          <img :src="imagepath" />
        </template>
      </mds-empty-state>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table";
import MdsCheckbox from "@mds/checkbox";
import MdsSearchField from "@mds/search-field";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import { MdsTag, MdsTagContainer } from "@mds/tag";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import MdsTooltip from "@mds/tooltip";
import MdsPopover from "@mds/popover";
import MdsIcon from "@mds/icon";
import MdsEmptyState from "@mds/empty-state";

export default Vue.extend({
  name: "AdlDataTable",
  components: {
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsSearchField,
    MdsButton,
    MdsButtonContainer,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsTag,
    MdsTagContainer,
    MdsListGroup,
    MdsListGroupItem,
    MdsTooltip,
    MdsPopover,
    MdsIcon,
    MdsCheckbox,
    MdsEmptyState,
  },
  props: {
    buttonText: {
      type: String,
    },
    actionButtonText: {
      type: String,
    },
    profiles: {
      type: Array,
    },
    tagName: {
      type: String,
    },
    factFindTag: {
      type: String,
    },
    headers: {
      type: Array,
      required: true,
    },
    rows: {
      type: Array,
    },
    actionButtons: {
      type: Array,
    },
    maxSelectedRow: {
      type: Number,
      default: 5,
    },
    isAllowCompare: {
      type: Boolean,
      default: true,
    },
    showEmptyState: {
      type: Boolean,
      default: false,
    },
    imagepath: { type: String },
  },

  data() {
    return {
      emptyState: this.showEmptyState,
      searchQuery: "",
      actionToggle: false,
      profileToggle: false,
      sortOrder: 1,
      sortColIndex: 0,
      selectedActionIndex: -1,
      selectedProfileIndex: -1,
      checkBoxSelectedColumnName: "",
      selectedMember: "",
    };
  },
  computed: {
    isCompareButtonDisable() {
      if (this.totalRowSelected < 2) {
        return true;
      }
      return false;
    },
    totalRowSelected() {
      if (this.rows && this.rows.length > 0)
        return this.rows.filter((sr) => sr["isSelected"]).length;
      else return 0;
    },
    compareButtonText() {
      if (this.totalRowSelected == 0) {
        return "Compare";
      }
      return `Compare ${this.totalRowSelected}/${this.maxSelectedRow}`;
    },
    emptyStateResult() {
      let returnData = this.rows;
      let instances = [];
      for (let i = 0; i < 4; i++) {
        instances.push(returnData[i].description);
      }
      return instances;
    },

    resultQuery() {
      if (this.searchQuery) {
        let result = this.rows.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every(
              (v) =>
                item.description.toLowerCase().includes(v) ||
                item.name.toLowerCase().includes(v) ||
                item.amount.toLowerCase().includes(v) ||
                item.date.toString().toLowerCase().includes(v)
            );
        });
        if (result.length == 0) this.emptyState = true;
        else this.emptyState = false;
        return result;
      } else {
        this.emptyState = false;
        return this.rows;
      }
    },
    emptyResultMessage() {
      let searchText = this.searchQuery;
      let sep = '"';
      return "No Results for " + sep + searchText + sep;
    },
  },
  watch: {
    rows: {
      handler: function (val) {
        this.searchQuery = "";
      },
    },
  },

  methods: {
    initialsColor(type) {
      if (type == 6) {
        return $style["cf-profileInitialJoint"];
      } else if (type == 2) {
        return `background-color: #099EC9; color: #fff`;
      }
    },
    setMember(member) {
      this.selectedMember = member;
      this.profileToggle = true;
    },
    getUserSelectedRow() {
      let userselectedRow = this.rows.filter(
        (sr) => sr[this.checkBoxSelectedColumnName]
      );
      this.$emit("compare", userselectedRow);
    },
    getrowmetadata(row, header) {
      let metaArray = [];
      let meta = header.metadata;
      for (let i = 0; i < meta.length; i++) {
        metaArray.push(meta[i].heading + header.split + " " + row[meta[i].key]);
      }
      return metaArray;
    },
    highlightSearchText(content) {
      if (!this.searchQuery) {
        return content;
      } else {
        return content.replace(new RegExp(this.searchQuery, "gi"), (match) => {
          return (
            '<span class="mds-search-results--text-match">' + match + "</span>"
          );
        });
      }
    },
    checkRowSelectedCount(index, columnName) {
      if (this.checkBoxSelectedColumnName == "") {
        this.checkBoxSelectedColumnName = columnName;
      }
      let checkedRow = this.rows.filter((sr) => sr[columnName]);
      if (checkedRow.length > this.maxSelectedRow) {
        this.rows[index][columnName] = false;
      }
    },
    handleSortEvent(colIndex) {
      this.sortOrder = this.sortOrder === 0 ? 1 : -this.sortOrder;
      if (this.sortColIndex !== null && this.sortColIndex !== colIndex) {
        this.$set(this.headers[this.sortColIndex], "sorted", 0);
        this.sortOrder = 1;
      }
      this.sortColIndex = colIndex;
      this.$set(this.headers[colIndex], "sorted", this.sortOrder);
        this.rows.sort( ( a, b) => {
        if (this.sortOrder == 1) {
          if (a.date == "Today")
            return new Date() - new Date(b.date)
          else if (b.date == "Today")
            return new Date(a.date) - new Date()
          else {
            return new Date(a.date) - new Date(b.date);
          }
        }
        if (a.date == "Today")
          return new Date(b.date) - new Date()
        else if (b.date == "Today")
          return new Date() - new Date(a.date)
        else
          return new Date(b.date) - new Date(a.date);
      });
             
         return this.items
 
    },
    
    selectedDetails(data) {
      this.$emit("clickloanDetails", data);
    },
  },
});
</script>

<style lang="scss" module>
.flexE {
  justify-content: flex-end;
  padding-right: 20px;
}

.cf-instanceSearchWrapper {
  margin-top: 7px;
  margin-left: 26px;
}
.cf-profileInitialsWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  span + span {
    left: -8px;
    background-color: #099ec9;
  }
}

.cf-profileInitials {
  display: flex;
  height: 28px;
  width: 28px;
  background-color: #fff38a;
  color: black;
  text-align: center;
  letter-spacing: 1.67px;
  border-radius: 50%;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 600;
  justify-content: center;
  align-items: center;
  position: relative;
}

.cf-profileInitialJoint {
  background-color: #589fa0;
  color: #fff;
}
.cf-profileInitialJoint + .cf-profileInitialJoint {
  background-color: #fff38a;
  color: black;
}
.cf-datatable {
  margin-top: 20px;
  padding: 20px;
}

.cf-tag {
  margin-top: 10px;
  text-align: right;
}

.cf-date {
  margin-top: 10px;
}

.cf-ActionHover {
  opacity: 0;
}

.cf-row:hover .cf-ActionHover {
  opacity: 1;
  margin-top: 10px;
}

.cf-row .cf-ActionHover.show {
  opacity: 1;
  margin-top: 10px;
}

.cf-row:hover [class^="mds-list-group-item__upper"] {
  text-decoration-line: underline;
}

.dataTableWrapper {
  padding: 16px;
}

.textR {
  text-align: right;
}

.removeExtraPadding > span > div {
  padding-left: 0px !important;
  padding-right: 0px !important;

  .mds-list-group-item__text {
    font-weight: 600 !important;
  }
}

.cf-blank-searchResults {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 320px;
  height: 271px;
  margin: 0 auto;
  margin-top: 32px;
}

.cf-tag-inner {
  min-width: auto;
  font-size: 10px;
  text-transform: uppercase;
  line-height: 16px;
  font-weight: bold;
  letter-spacing: 1.67px;
  margin-left: 8px;
  background-color: #00beaf !important;
  color: black !important;
}
.cf-tag-outer {
  min-width: auto;
  font-size: 10px;
  color: #ffffff !important;
  text-transform: uppercase;
  line-height: 16px;
  font-weight: bold;
  letter-spacing: 1.67px;
  margin-left: 8px;
  background-color: black !important;
}
.textR {
  text-align: left;
  margin-top: 8px;
}
</style>
<style>
.mds-search-results--text-match {
  background-color: #0077cf26;
}
</style>
